export var years = Array(200).fill(0).map(function (_, index) { return String(index + 1900); });
export var months = Array(12).fill(0).map(function (_, index) { return String(index + 1); });
